export const getAuthenticatedCustomerName = (): string | null => {
  const customerName = localStorage.getItem('customerName');
  const customerId = localStorage.getItem('customerId');
  const jwt = localStorage.getItem('jwt');

  if (!customerId || !jwt) {
    localStorage.removeItem('customerName');
    return null;
  }

  if (!customerName) {
    return null;
  }

  const trimmedName = customerName.trim();
  if (!trimmedName || trimmedName === 'undefined') {
    return null;
  }

  return trimmedName;
};

export const isCustomerLoggedIn = (): boolean => {
  return Boolean(localStorage.getItem('customerId') && localStorage.getItem('jwt'));
};

export const logoutCustomer = (): void => {
  localStorage.removeItem('jwt');
  localStorage.removeItem('customerId');
  localStorage.removeItem('customerName');
  localStorage.removeItem('role');
  localStorage.removeItem('cartId');
  sessionStorage.removeItem('email');
  sessionStorage.removeItem('phonepe-payment-pending');
};